import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User } from '../../../shared/models';
import { CPATTERN } from '../../../shared/helpers/app.constants';
import { ManageUsersService } from './manage-users.service';
import { LoadingOverlayService } from '../../../shared/services';
import { find, cloneDeep, isEqual } from 'lodash';

@Component({
  selector: 'app-users-detail',
  templateUrl: './users-detail.component.html',
  styleUrls: ['./users-detail.component.scss']
})
export class UsersDetailComponent implements OnInit {
  @Input() listRoles: { name: string; value: string; }[] = [];
  @Input() detail: any;
  @Input() currentUser: User;
  @Input() userRole: string;
  @Input() currentCompanyId: any;

  roleDisabled: boolean = false;
  selectedListRoles: any[] = [];

  userForm: FormGroup;
  userName: AbstractControl;
  firstName: AbstractControl;
  lastName: AbstractControl;
  role: AbstractControl;
  email: AbstractControl;

  originFormValue: any;

  constructor(
    protected dialogRef: NbDialogRef<any>,
    private fb: FormBuilder,
    private manageUsersService: ManageUsersService,
    private loadingOverlayService: LoadingOverlayService
  ) { }

  ngOnInit() {
    this.createForm();
    if (this.detail) {
      const formData = { ...this.detail };
      this.userForm.setValue({
        userName: formData.userName || '',
        firstName: formData.firstName || '',
        lastName: formData.lastName || '',
        email: formData.email || '',
        role: formData.roles[0] || '',
      });
      if (this.currentUser && this.currentUser.email === this.detail.email) {
        this.role.disable();
        this.roleDisabled = true;
      }
      const roleValue = find(this.listRoles, {value: formData.roles[0]});
      if (roleValue) {
        this.selectedListRoles = [roleValue];
      }
      this.originFormValue = cloneDeep(this.userForm.value);
    } else {
      if (this.listRoles && this.listRoles.length > 0) {
        this.selectedListRoles = [this.listRoles[0]];
        this.role.setValue(this.listRoles[0].value);
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  createForm() {
    this.userForm = this.fb.group({
      userName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern('[A-Za-z0-9]*')]],
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern('[A-Za-z]*')]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern('[A-Za-z]*')]],
      role: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.maxLength(191), Validators.pattern(CPATTERN.EMAIL)]],
    });
    this.userName = this.userForm.controls['userName'];
    this.firstName = this.userForm.controls['firstName'];
    this.lastName = this.userForm.controls['lastName'];
    this.role = this.userForm.controls['role'];
    this.email = this.userForm.controls['email'];
  }

  submitForm() {
    // submit form
    if (this.detail && this.detail.id) {
      if (!isEqual(this.originFormValue, this.userForm.value)) {
        this.handleEdit(this.detail.id, this.userForm.value);
      } else {
        this.dialogRef.close();
      }
    } else {
      this.handleCreate(this.userForm.value);
    }
  }

  handleCreate(data) {
    // call api create user record
    if (data) {
      const payload = this.toCreatePayload(this.currentCompanyId, data);
      this.loadingOverlayService.show();
      this.manageUsersService.addUser(this.userRole, payload).subscribe((res) => {
        this.dialogRef.close(data);
        this.loadingOverlayService.hide();
      }, err => {
        this.loadingOverlayService.hide();
      });
    }
  }

  handleEdit(id, data) {
    // call api update user record
    if (id && data) {
      this.loadingOverlayService.show();
      const payload = this.toEditPayload(data);
      this.manageUsersService.updateUser(this.userRole, id, payload).subscribe((res) => {
        this.dialogRef.close(data);
        this.loadingOverlayService.hide();
      }, err => {
        this.loadingOverlayService.hide();
      });
    }
  }

  toCreatePayload(companyId: string | number, data) {
    if (data) {
      companyId = companyId ? companyId : null;
      const result = {...data};
      result.companyId = companyId;

      return result;
    }
    return;
  }

  toEditPayload(data) {
    if (data) {
      const result = {...data};
      if (data.role) {
        result.roles = [
          data.role
        ];
        delete result.role;
      }
      return result;
    }
    return;
  }
}
